import styleInject from '../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".remediation-confirmation-item-box{width:180px!important}@media only screen and (max-width:767px){.remediation-confirmation-item-box{width:100%!important}}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
